import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://rvxlugwkeqfdghwbholl.supabase.co';
const supabaseKey = 'sb_publishable_PPO_KufXHbUOVQmlwIL3rw_6y3d5eXX';

export const supabase = createClient(supabaseUrl, supabaseKey);
export { supabaseUrl, supabaseKey };